export function waitAntdStylesLoad(timeoutMS = 2000, throwOnTimeout: false | 'throw' = false) {
  return new Promise<void>((resolve, reject) => {
    let timeout: NodeJS.Timeout;

    // create fake elements
    const container = document.createElement('div');

    container.innerHTML = `
            <div class="ant-select ant-select-single ant-select-show-arrow">
                <div class="ant-select-selector">
                </div>
            </div>
        `;

    container.style.position = 'fixed';
    container.style.top = '-1000px';
    container.style.left = '-1000px';

    document.body.appendChild(container);

    const finish = (status: 'good' | 'reject') => {
      if (elWithTransition) {
        elWithTransition.removeEventListener('transitionend', transitionEndHandler);
      }
      clearTimeout(timeout);
      container.remove();

      if (status === 'reject') reject();
      else resolve();
    };

    const elWithTransition = container.querySelector('.ant-select-selector');
    const transitionEndHandler = () => finish('good');

    if (elWithTransition) {
      elWithTransition.addEventListener('transitionend', transitionEndHandler);
    }

    if (timeoutMS) {
      timeout = setTimeout(() => {
        finish(throwOnTimeout === 'throw' ? 'reject' : 'good');
      }, timeoutMS);
    }
  });
}
